import { render, staticRenderFns } from "./FinalLabButton.vue?vue&type=template&id=bb8e8716"
import script from "./FinalLabButton.vue?vue&type=script&lang=js"
export * from "./FinalLabButton.vue?vue&type=script&lang=js"
import style0 from "./FinalLabButton.vue?vue&type=style&index=0&id=bb8e8716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports